var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.4375C1.75 14.1758 2.32422 14.75 3.0625 14.75H10.9375C11.6484 14.75 12.25 14.1758 12.25 13.4375V4.25H1.75V13.4375ZM9.1875 6.4375C9.1875 6.21875 9.37891 6 9.625 6C9.84375 6 10.0625 6.21875 10.0625 6.4375V12.5625C10.0625 12.8086 9.84375 13 9.625 13C9.37891 13 9.1875 12.8086 9.1875 12.5625V6.4375ZM6.5625 6.4375C6.5625 6.21875 6.75391 6 7 6C7.21875 6 7.4375 6.21875 7.4375 6.4375V12.5625C7.4375 12.8086 7.21875 13 7 13C6.75391 13 6.5625 12.8086 6.5625 12.5625V6.4375ZM3.9375 6.4375C3.9375 6.21875 4.12891 6 4.375 6C4.59375 6 4.8125 6.21875 4.8125 6.4375V12.5625C4.8125 12.8086 4.59375 13 4.375 13C4.12891 13 3.9375 12.8086 3.9375 12.5625V6.4375ZM12.6875 1.625H9.40625L9.13281 1.13281C9.02344 0.914062 8.80469 0.75 8.55859 0.75H5.41406C5.16797 0.75 4.94922 0.914062 4.83984 1.13281L4.59375 1.625H1.3125C1.06641 1.625 0.875 1.84375 0.875 2.0625V2.9375C0.875 3.18359 1.06641 3.375 1.3125 3.375H12.6875C12.9062 3.375 13.125 3.18359 13.125 2.9375V2.0625C13.125 1.84375 12.9062 1.625 12.6875 1.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1d8802ddea96e307cf1e439a000f696b.svg";
export { ForwardRef as ReactComponent };